export default __webpack_public_path__ + "static/media/file-fallback.39aef55c.jpg";